.button {
  min-height: var(--haus-logoutbutton__button__min-height, 40px);
  height: var(--haus-logoutbutton__button__height, 40px);
}
